import React, {useContext} from 'react';
import UserContext from '../common/UserContext.js';

// components
import {DateCell, DateIsExpiredCell} from '../common/Grid.js';

// multilingual
import {useLocalization} from '@progress/kendo-react-intl';
import {
    fsaDetailsKey,
    currencyKey,
    customerInformationKey,
    endDateKey,
    remixTypeKey,
    startDateKey,
    statusKey,
    overdraftKey,
    mainMessages
} from '../../assets/text/MultilingualText.js';

const DetailedViewInfo = (props) => {
    const {siteLanguageDefault} = useContext(UserContext);
    const {fsaDetails} = props;
    const localization = useLocalization();

    return (
        <div
            style={{
                display: 'flex',
                gap: '1.9rem',
            }}>
            <div>
                <div className={'k-h5'}>
                    {localization.toLanguageString(customerInformationKey, mainMessages[siteLanguageDefault][customerInformationKey])}
                </div>
                <table>
                    <tbody>
                    {fsaDetails?.customer_name && (
                        <tr>
                            <td>
                                {fsaDetails.customer_name}
                            </td>
                        </tr>
                    )}
                    {fsaDetails?.customer_address && (
                        <tr>
                            <td>
                                {fsaDetails.customer_address}
                            </td>
                        </tr>
                    )}
                    {(fsaDetails?.customer_city || fsaDetails?.customer_state || fsaDetails?.customer_zip_code) && (
                        <tr>
                            <td>
                                {fsaDetails.customer_city && fsaDetails.customer_state && (
                                    fsaDetails.customer_city + ', ' + fsaDetails.customer_state + ' '
                                )}
                                {fsaDetails.customer_zip_code && (
                                    fsaDetails.customer_zip_code
                                )}
                            </td>
                        </tr>
                    )}
                    {fsaDetails?.customer_country && (
                        <tr>
                            <td>
                                {fsaDetails.customer_country}
                            </td>
                        </tr>
                    )}
                    {fsaDetails?.customer_email && (
                        <tr>
                            <td>
                                {fsaDetails.customer_email}
                            </td>
                        </tr>
                    )}
                    </tbody>
                </table>
            </div>
            <div>
                <div className={'k-h5'}>
                    {localization.toLanguageString(fsaDetailsKey, mainMessages[siteLanguageDefault][fsaDetailsKey])}
                </div>
                <table
                    style={{
                        borderSpacing: '0.938rem 2px',
                        marginLeft: '-0.938rem',
                    }}
                >
                    <tbody>
                        <tr>
                            <td>
                                {localization.toLanguageString(startDateKey, mainMessages[siteLanguageDefault][startDateKey])}
                            </td>
                            {fsaDetails?.start_date && (
                                DateCell({field: 'start_date', dataItem: {'start_date': fsaDetails.start_date}})
                            )}
                        </tr>
                        <tr>
                            <td>
                                {localization.toLanguageString(endDateKey, mainMessages[siteLanguageDefault][endDateKey])}
                            </td>
                            {fsaDetails?.end_date && (
                                DateIsExpiredCell({field: 'end_date', dataItem: {'end_date': fsaDetails.end_date}})
                            )}
                        </tr>
                        <tr>
                            <td>
                                {localization.toLanguageString(statusKey, mainMessages[siteLanguageDefault][statusKey])}
                            </td>
                            <td className={'capital-letters'}>
                                {fsaDetails?.status && (
                                    fsaDetails.status
                                )}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                {localization.toLanguageString(currencyKey, mainMessages[siteLanguageDefault][currencyKey])}
                            </td>
                            <td>
                                {fsaDetails?.currency_code && (
                                    fsaDetails.currency_code
                                )}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                {localization.toLanguageString(overdraftKey, mainMessages[siteLanguageDefault][overdraftKey])}
                            </td>
                            <td>
                                {fsaDetails?.overdraft_percentage && (
                                    fsaDetails.overdraft_percentage
                                )}%
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default DetailedViewInfo;